<div   *ngIf="membershipLevelData" class="mct-gap-8 mct-grid-gt-sm mct-cols-1-1-gt-sm">
  <div class="mt-8" *ngFor="let item of membershipLevelData.MembershipLevelItems">
    <p-checkbox [binary]="true" inputId="affCode"> </p-checkbox>
    <label for="affCode">
      {{ item.DisplayName ? item.DisplayName : item.RealName }}
    </label>
  </div>
</div>
